import React from 'react';
import Footer from '../components/reusableComponents/Footer';
import Headers from '../components/reusableComponents/Headers';

const ProfileSection = () => {
	return (
		<>
			<Headers />
			<Footer />
		</>
	);
};

export default ProfileSection;
